import React, { FC } from "react";

export interface CheckmarkProps {
    /**
     * Size of the checkmark.  It will be applied to both the width and height.
     *
     * Example values include; "2em", "50", "50px"
     */
    size?: string;
    /**
     * Color of the checkmark.
     *
     * Example values include: "#0000FF", "green", "cyan"
     */
    color?: string;
}

const defaultProps: CheckmarkProps = {
    color: "#00A6DE",
    size: "20px"
};

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

export const Checkmark: FC<CheckmarkProps> = props => {
    const mergedProps = { ...defaultProps, ...props };
    const { size, color } = mergedProps;
    const outsideProps: any = {};

    if (size) {
        outsideProps.width = size;
        outsideProps.height = size;
    }

    return (
        <span style={style}>
            <svg {...outsideProps} fill={color} version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
                <g transform="translate(0,-952.36218)">
                    <path
                        fill={color}
                        fillOpacity="1"
                        stroke="none"
                        visibility="visible"
                        display="inline"
                        overflow="visible"
                        style={{
                            baselineShift: "baseline",
                            color: "#000000",
                            direction: "ltr",
                            msBlockProgression: "tb",
                            textIndent: 0,
                            textTransform: "none"
                        }}
                        d="m 75.889252,977.3292 a 8.0008,8.0008 0 0 0 -5.5,2.4375 c -9.0282,9.04775 -19.3274,19.32305 -28.8126,28.8125 l -12.4062,-10.31245 a 8.0008,8.0008 0 1 0 -10.25,12.28115 l 18,15 a 8.0008,8.0008 0 0 0 10.7812,-0.5 c 10.6539,-10.6767 23.3205,-23.2973 34,-33.99995 a 8.0008,8.0008 0 0 0 -5.8124,-13.71875 z"
                    />
                </g>
            </svg>
        </span>
    );
};
